export class Global {
    public static currentTheme: any;
    public static deviceType: string;
    public static screenWidth: number;
    public static sessionId: string;
    public static applicationId: string;
}